import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { required, withMessage } from '@certemy/common';
import { sortItemByName } from 'utils/helpers';
import {
  LocationTypesCountryDictionaryItem,
  LocationTypesOfficeDictionaryItem,
  LocationTypesRegionDictionaryItem,
} from 'services/locations/locations.constant';
import _get from 'lodash-es/get';
import { SmartFilters } from '@certemy/ui-components';
import {
  DEFAULT_LABEL_SETTINGS,
  GlobalOrganizationsLabel,
  OrganizationsLabelType,
} from 'features/global-organizations-setting-state/global-organizations-setting.constant';

const requiredWithMessage = withMessage('Please fill out all fields', required);

@Component({
  selector: 'cm-invite-location-block',
  templateUrl: './invite-location-block.component.html',
  styleUrls: ['./invite-location-block.component.scss'],
})
export class InviteLocationBlockComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() disabled: boolean = false;
  @Input() locations;
  @Input() showError;
  @Input() profile;
  @Input() organizationLabels: GlobalOrganizationsLabel = DEFAULT_LABEL_SETTINGS;

  allCountries: LocationTypesCountryDictionaryItem[] = [];
  allRegions: LocationTypesRegionDictionaryItem[] = [];
  allOffices: LocationTypesOfficeDictionaryItem[] = [];
  regions: SmartFilters.FilterOption[] = [];
  offices: SmartFilters.FilterOption[] = [];

  readonly OrganizationsLabelType = OrganizationsLabelType;

  ngOnInit() {
    this.form.addControl(
      'countryId',
      new UntypedFormControl(
        {
          value: this.profile.countryId || null,
          disabled: this.disabled,
        },
        requiredWithMessage,
      ),
    );
    this.form.addControl(
      'regionId',
      new UntypedFormControl(
        {
          value: this.profile.regionId || null,
          disabled: this.disabled || !this.profile.countryId,
        },
        requiredWithMessage,
      ),
    );
    this.form.addControl(
      'officeId',
      new UntypedFormControl(
        {
          value: this.profile.officeId || null,
          disabled: this.disabled || !this.profile.regionId,
        },
        requiredWithMessage,
      ),
    );
    this.setAllLocations();
  }

  private setAllLocations() {
    const { offices, regions, countries } = this.locations;
    this.allOffices = sortItemByName(_get(offices, 'dictionaryItems', []));
    const validRegions: { [key: number]: boolean } = {};
    this.allOffices.forEach((office: LocationTypesOfficeDictionaryItem) => {
      if (office.regionId) {
        validRegions[office.regionId] = true;
      }
    });
    this.offices = this.allOffices;
    const validCountries: { [key: number]: boolean } = {};
    this.allRegions = sortItemByName(
      _get(regions, 'dictionaryItems', []).filter((region: LocationTypesRegionDictionaryItem) => {
        if (validRegions[region.id]) {
          if (region.countryId) {
            validCountries[region.countryId] = true;
          }
          return true;
        }
        return false;
      }),
    );
    this.regions = this.allRegions;
    this.allCountries = sortItemByName(
      _get(countries, 'dictionaryItems', []).filter((country: LocationTypesCountryDictionaryItem) => {
        return validCountries[country.id];
      }),
    );
  }

  onCountryChange(country_id) {
    const countryId: number = parseInt(country_id.toString(), 10);
    this.regions = this.allRegions.filter(({ countryId: regionCountyId }) => regionCountyId === countryId);
    this.form.patchValue({
      regionId: null,
      officeId: null,
    });
  }

  onRegionChange(region_id) {
    const regionId: number = parseInt(region_id.toString(), 10);
    this.offices = this.allOffices.filter(({ regionId: officeRegionId }) => officeRegionId === regionId);
    this.form.patchValue({
      officeId: null,
    });
  }
}
